export default __webpack_public_path__ + "static/social-card-301a9d3768caef17224af0950d0581f7.png";